import { useContext } from "react";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import classes from "./HowWeWork.module.css";
import { MyContext } from "../../Context/MyContext";
import { requestBookCall } from "../../lib/bookCall";

const steps = [
  {
    number: "01",
    title: "Discover",
    copy: "We learn your goals, audience, and constraints so the work has a clear job.",
  },
  {
    number: "02",
    title: "Design",
    copy: "We shape the product, brand, and plan before a single sprint is wasted.",
  },
  {
    number: "03",
    title: "Build",
    copy: "We ship software, campaigns, and support systems your team can actually use.",
  },
  {
    number: "04",
    title: "Grow",
    copy: "We measure, iterate, and keep the engine running after launch.",
  },
];

export default function HowWeWork() {
  const { processRef } = useContext(MyContext);
  const navigate = useNavigate();

  return (
    <section ref={processRef} className={`sectionShell ${classes.section}`} id="process">
      <Container>
        <div className={classes.intro}>
          <div className="sectionEyebrow">How we work</div>
          <h2 className="sectionTitle">A clear path from brief to results</h2>
          <p className="sectionLead">
            Four steps. No mystery retainers. You always know what happens next.
          </p>
        </div>
        <ol className={classes.steps}>
          {steps.map((step) => (
            <li key={step.number} className={classes.step}>
              <span className={classes.number}>{step.number}</span>
              <h3>{step.title}</h3>
              <p>{step.copy}</p>
            </li>
          ))}
        </ol>
        <button
          type="button"
          className="buttonHome"
          onClick={() => requestBookCall(navigate)}
        >
          Book a Call
        </button>
      </Container>
    </section>
  );
}
